var _path, _path2, _circle, _path3, _path4, _circle2, _circle3, _circle4, _g, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeMotivation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60L114.092 69.6872L116.396 80.8397L107.571 87.8802L105.963 99.1571L95.3001 102.714L90.0055 112.762L78.7882 112.409L70.4186 120L60.0003 115.756L49.5814 120L41.2118 112.409L29.9938 112.762L24.6999 102.714L14.0365 99.1571L12.4293 87.8795L3.6036 80.8397L5.90754 69.6872L0 60L5.90754 50.3121L3.6036 39.1597L12.4293 32.1198L14.0371 20.8423L24.6999 17.2856L29.9944 7.23784L41.2118 7.59125L49.5814 0L60.0003 4.24352L70.4186 0L78.7882 7.59125L90.0062 7.23784L95.3001 17.2862L105.964 20.8429L107.571 32.1198L116.396 39.1603L114.092 50.3121L120 60Z",
    fill: "#FD6BFE",
    fillOpacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9961 108.914C86.6017 108.914 108.17 87.0168 108.17 60.0052C108.17 32.9937 86.6017 11.0964 59.9961 11.0964C33.3904 11.0964 11.8223 32.9937 11.8223 60.0052C11.8223 87.0168 33.3904 108.914 59.9961 108.914Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1011,
    cy: 60.005,
    r: 32.1148,
    fill: "#FD6BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3594 31.8326C74.243 33.2469 77.751 35.442 80.6953 38.2271L30.9395 66.9537C30.4101 64.7236 30.1289 62.3974 30.1289 60.0054C30.1289 58.2299 30.283 56.4901 30.5791 54.7994L70.3594 31.8326Z",
    fill: "#FFCFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9219 43.2007C88.1729 47.9937 90.0732 53.7776 90.0732 60.0054C90.0732 61.7808 89.9171 63.5199 89.6211 65.2105L49.8428 88.1763C42.5112 85.5063 36.5169 80.0565 33.1328 73.1011L84.9219 43.2007Z",
    fill: "#FFCFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1016,
    cy: 60.005,
    r: 23.5508,
    fill: "#CD3BCE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0993,
    cy: 60.005,
    r: 21.4098,
    fill: "#FD6BFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_6271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 44,
    height: 44
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0993,
    cy: 60.005,
    r: 21.4098,
    fill: "#00A4B3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_6271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.41 95.8665L72.4076 57.3288L59.5617 60.005L52.6035 71.2452L91.1412 109.783L110.41 95.8665Z",
    fill: "#CD3BCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6373 86.7673L60.0996 48.2296V60.005L98.6373 98.5427V86.7673Z",
    fill: "#CD3BCE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1 48.2296L63.8753 55.8792L72.4106 57.3287L66.2086 63.0603L67.5934 71.2451L60.1 67.4984L52.6065 71.2451L53.9914 63.0603L47.8828 57.1059L56.3247 55.8792L60.1 48.2296Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0859 30.9182C93.8604 38.1096 98.7395 48.472 98.7395 59.9914C98.7395 66.7985 97.0359 73.2011 94.0376 78.7848",
    stroke: "#2D3962",
    strokeWidth: 3.34997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2141 30.9182C25.4397 38.1096 20.5605 48.472 20.5605 59.9914C20.5605 66.7985 22.2642 73.2011 25.2624 78.7848",
    stroke: "#2D3962",
    strokeWidth: 3.34997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeMotivation2);
export default __webpack_public_path__ + "static/media/badge-motivation2.e3025238cd798ef6a054f5a3b9735ad6.svg";
export { ForwardRef as ReactComponent };